import React from 'react';
import ArchiveItem from '../../components/ArchiveItem';
function ArchivePage() {
  return <ArchiveItem />;
}

export default ArchivePage;